var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-heading"},[_c('div',{staticClass:"m-heading__line"}),(!_vm.lineOnly)?_c('p',{staticClass:"m-heading__text",attrs:{"data-aos":"fade"}},[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }